import {useEffect, useState} from "react";
import {kakaoLogin, loginUser} from "../api/auth/auth.api";
import { SET_TOKEN } from "../store/auth";
import { useDispatch } from "react-redux";
import { setRefreshToken } from "../storage/cookie";
import OMOPlayLogo from "../assets/images/logo_omoplay_black.svg";
import {ArrowDropDownIcon, ArrowDropUpIcon, Button} from "omoplay";
import {getAccount} from "../api/account/account.api";
import KakaoIcon from "../assets/images/icon.kakaotalk_only.svg";
import {useSearchParams} from "react-router-dom";

const LoginPage = ({isModel = false, type, onLogin}) => {
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setLoading] = useState(false);
  /**
   * 카카오 로그인 영역 펼침 상태 (2026-08-21)
   *
   * ## 왜 기본이 '접힘' 인가
   *
   * 종전에는 **카카오 간편 로그인이 맨 위**에 있고 아이디/비밀번호가 '일반 로그인' 토글 안에 접혀 있었다.
   * 그래서 오랜만에 `admin.omoplay.com` 에 온 고객이 **습관적으로 카카오를 눌러 계정이 하나 더 생기는**
   * 일이 잦았다(같은 사람에게 계정 2개 → 채널 권한이 갈려 CS 로 이어진다).
   *
   * 현재 신규 가입은 **아이디/비밀번호 기반으로만 유도**하고 있으므로 화면도 그에 맞춘다 —
   * 아이디/비밀번호가 기본, 카카오는 **이미 카카오로 가입한 사람만** 펼쳐서 쓰는 보조 수단이다.
   */
  const [isKakaoOpen, setKakaoOpen] = useState(false)
  const [query] = useSearchParams()

  useEffect(() => {
    const token = query.get("token")
    const type = query.get("type")

    if (token) {
      setRefreshToken(token);
      if (type === "tutorial") {
        window.location.href = "/agent/tutorial"
      } else {
        window.location.href = "/"
      }
    }
  }, []);

  const requestLegacyLogin = () => {
    setLoading(true);
    loginUser({
      username: username,
      password: password,
    }).then(({data}) => {
      if (data.data !== "error") {
        dispatch(SET_TOKEN(data));
        setRefreshToken(data.data);
        getAccount().then(({data}) => {
          if (data && data.channelId !== 0) {
            localStorage.setItem("channelState", data.channelId)
          }
          if (isModel) {
            onLogin()
          } else {
            window.location.href = "/"
          }
        })
      } else {
        alert("로그인에 실패하였습니다. 계정 정보를 다시 확인해주세요");
        setLoading(false);
      }
    });
  };

  const requestKakaoLogin = () => {
    kakaoLogin(type ?? "login").then(({data}) => {
      window.location.href = data
    })
  }

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      requestLegacyLogin();
    }
  };

  return (
    <div className="w-full flex justify-center items-center login-background-gradient">
      {/* `justify-center` → `my-auto`(2026-08-21). 중앙정렬은 내용이 화면보다 길어질 때
          넘친 위쪽을 잘라내고 스크롤로도 닿을 수 없다('일반 로그인'을 펼치면 작은 화면에서 발생).
          높이도 `100dvh` 를 함께 줘서 모바일 키보드가 올라오면 컨테이너가 같이 줄게 한다. */}
      <div className={`${isModel ? "" : "min-h-screen min-h-[100dvh] "}flex-1 bg-white flex flex-col pt-[40px] px-[10px] pb-[20px]`}>
        <div className="w-full my-auto flex flex-col items-center">
          <div className="w-full max-w-[358px]">
            <div className="flex justify-center" style={{marginBottom: "20px"}}>
              <img alt="" src={OMOPlayLogo} width="272px" />
            </div>
            <div className="text-center" style={{marginBottom: "43px"}}>NO.1 온오프라인 브랜드사 고객 마케팅 서비스</div>
            <div className="bg-white shadow-lg rounded-[16px] p-[32px] flex-col gap-[20px] border border-gray-300">
              <div className="text-[24px] font-bold">로그인</div>
              {/*
                아이디/비밀번호를 기본으로 노출한다(2026-08-21). 종전에는 이 영역이 '일반 로그인' 토글
                안에 접혀 있고 카카오가 맨 위였다 — 사유는 `isKakaoOpen` 주석 참고.
              */}
              <>
                      <div className="mb-4">
                        <label
                            className="block text-gray-700 text-sm font-bold mb-2"
                            htmlFor="username"
                        >
                          아이디
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="username"
                            type="text"
                            placeholder="아이디를 입력해 주세요."
                            onChange={(e) => setUsername(e.target.value)}
                            value={username}
                        />
                      </div>
                      <div className="mb-6">
                        <label
                            className="block text-gray-700 text-sm font-bold mb-2"
                            htmlFor="password"
                        >
                          비밀번호
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                            id="password"
                            type="password"
                            placeholder="비밀번호를 입력해 주세요."
                            onChange={(e) => setPassword(e.target.value)}
                            onKeyDown={(e) => handleKeyDown(e)}
                            value={password}
                        />
                      </div>
                      <div className="flex-col gap-4">
                        <Button
                            variants="primary"
                            disabled={isLoading}
                            size="large"
                            onClick={() => requestLegacyLogin()}
                            value="로그인"
                        />
                        <Button
                            variants="secondary"
                            onClick={() => window.location.href = "/account/join"}
                            value="회원가입"
                        />
                        <div className="flex flex-col items-center gap-2 text-center font-medium text-[14px] text-tertiary">
                          <div className="underline pointer" onClick={() => window.location.href = "/account/find/id"}>아이디 확인이 필요하신가요?</div>
                          <div className="underline pointer" onClick={() => window.location.href = "/account/find/pwd"}>비밀번호를 잊으셨나요?</div>
                        </div>
                      </div>
              </>

              {/*
                카카오 로그인 — **기본 접힘**. 이미 카카오로 가입한 고객만 펼쳐서 쓰는 보조 수단이다.
                펼쳤을 때 중복 계정 주의를 함께 보여준다(습관적으로 눌러 계정이 하나 더 생기는 것이 실제 문제였다).
              */}
              <div className="border-t border-gray-200 pt-[20px] flex-col gap-[12px]">
                <div
                    className="flex-center-all w-full gap-1 pointer"
                    onClick={() => setKakaoOpen(!isKakaoOpen)}
                >
                  <div className="underline text-[14px] text-tertiary font-medium">카카오 로그인</div>
                  <div>
                    {
                      isKakaoOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />
                    }
                  </div>
                </div>
                {
                  isKakaoOpen && (
                      <>
                        <div className="flex-center-all p-[14px] bg-[rgb(255,220,0)] rounded-[8px] pointer"
                             onClick={() => requestKakaoLogin()}
                        >
                          <div><img src={KakaoIcon} alt="kakao" /></div>
                          <div>카카오 간편 로그인 / 회원가입</div>
                        </div>
                        <div className="text-[13px] text-tertiary leading-relaxed">
                          이미 <strong>카카오로 가입</strong>하신 경우에만 이용해 주세요.
                          아이디로 가입한 계정이 있는데 카카오로 로그인하면 <strong>계정이 따로 만들어집니다.</strong>
                        </div>
                      </>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* 오른쪽 그라디언트 여백 — 좁은 화면에서는 숨긴다(종전의 `window.innerWidth` 1회 계산은 회전에 반응하지 않았다) */}
      <div className="hidden sm:flex flex-1 flex-center-all"></div>
    </div>
  );
};
export default LoginPage;
